import { cn } from '../../lib/cn';

type Props = {
  value: number;
  label?: string;
  eta?: string;
  showPercent?: boolean;
  className?: string;
};

export function ProgressFeedback({ value, label, eta, showPercent = true, className }: Props) {
  const pct = Math.min(100, Math.max(0, Math.round(value)));
  return (
    <div className={cn('space-y-2', className)} role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} aria-label={label ?? 'Progress'}>
      {(label || showPercent) && (
        <div className="flex items-center justify-between text-xs">
          {label && <span className="font-medium text-slate-700 dark:text-slate-300">{label}</span>}
          {showPercent && <span className="font-mono text-slate-500">{pct}%</span>}
        </div>
      )}
      <div className="h-2 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
        <div
          className="h-full rounded-full bg-brand-600 transition-all duration-300 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      {eta && <p className="text-xs text-slate-500">Estimated time remaining: {eta}</p>}
    </div>
  );
}
